<template>
  <div>
    <v-container container--fluid grid-list-xl>
      <v-row justify="center" align="center">
        <v-col cols="6" class="text-center align-center">
          <v-icon x-large color="green">fas fa-check-circle</v-icon>
          <h3>Your invoices has been uploaded successfully </h3>
          <h4>(Here is a summary of the lines that have been processed)</h4>
        </v-col>

        <v-col>
          <v-card class="elevation-2">
            <v-card-title>
              <h2 class="mr-2">Processed Invoices</h2>

              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-btn icon size="35" color="green" v-on="on" @click="csvExport">
                    <v-icon color="green">cloud_download</v-icon>
                  </v-btn>
                </template>
                <span>Export CSV</span>
              </v-tooltip>

            </v-card-title>
            <v-divider></v-divider>
            <v-data-table

              :headers="headers"
              :items="results"
              :items-per-page="25"
            >
              <template v-slot:item="props">
                <tr>
                  <td style="text-align: center" v-for="(header, index) in headers" :key="index">
                    {{props.item[header.value]}}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="mt-8 mb-4">
        <v-btn text block color="blue darken-1" @click="$router.go()">Next Invoice File Upload</v-btn>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// @vuese
//
// @group Invoices
export default {
  name: "InvoiceSummary",
  props: {
    results: Array,

  },
  data() {
    return {
      headers: [
        { text: 'Id', value: 'id', align: 'center', sortable: true, width: '10%'},
        { text: 'Client Name', value: 'client_name', align: 'center', sortable: true , width: '20%'},
        { text: 'State', value: 'state', align: 'center', sortable: true, width: '15%' },
        { text: 'Postcode', value: 'postcode', align: 'center', sortable: true , width: '15%'},
        { text: 'Invoice Date', value: 'date', align: 'center', sortable: true , width: '20%'},
        { text: 'Total', value: 'total', align: 'center', sortable: true , width: '20%'},
      ],
    }
  },
  methods: {
    // Exports all the processed lines (the approved ones) in a CSV file.
    csvExport() {
       let arrData = this.results;

      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [
        Object.keys(arrData[0]).join(","),
        ...arrData.map(item =>
        { let row = Object.values(item).map((value) => {return '\"' + value + '\"'})
          return row.join(",")
        })
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "invoices.csv");
      link.click();

    },
  }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/util/Invoices/InvoiceSummary.vue